var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 4.83419L11.666 7.50085M2.66602 13.8342H5.33268L12.3327 6.83419C12.6863 6.48056 12.885 6.00095 12.885 5.50085C12.885 5.00076 12.6863 4.52114 12.3327 4.16752C11.9791 3.8139 11.4994 3.61523 10.9993 3.61523C10.4993 3.61523 10.0196 3.8139 9.66602 4.16752L2.66602 11.1675V13.8342Z",
    stroke: "#0B93E3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.982f4d2eb5d90c37c936dcbfc591a7c3.svg";
export { ForwardRef as ReactComponent };